"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _makeObjectRecord = _interopRequireDefault(require("../record/makeObjectRecord"));

var _ObjectTypes = require("../constants/ObjectTypes");

var _ObjectIds = _interopRequireDefault(require("../constants/ObjectIds"));

var _default = (0, _makeObjectRecord.default)({
  idKey: _ObjectIds.default[_ObjectTypes.PRODUCT],
  objectType: _ObjectTypes.PRODUCT,
  recordName: 'ProductRecord',
  defaults: {
    properties: (0, _immutable.Map)(),
    objectId: null
  }
}, {
  primary: ['name']
});

exports.default = _default;
module.exports = exports.default;